import {gql} from 'apollo-angular'

export const PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT = gql`
    fragment ProjectCreditOutletFields on ProjectCreditOutlet {
      id
      ownership
      fundProjectState {
        name
      }
      admitted_date
      is_target
      is_target_exit
      load_percentage
      exit_date
      ut_irr
      revenue_year
      gross_equity
      estimated_gross_equity
      warehoused
      is_target_investor_approval
      investor_approval_date
      projected_warehouse_days
      revenue_adjustments {
        id
        revenue_year
        amount
      }
      fundProjectState {
        id
        name
      }
      projectCredit {
        id
        amount
        price
        equity_amount
        crea_syndicated
        taxCreditType {
          name
          level
          id
        }
        taxCreditDesignation {
          name
          id
        }
        project {
          name
          id
          projectDetail {
            id
            syndications_notes
            is_flagged_syndications
          }
          taggedParticipants {
            id
            person {
              id
              name
            }
            organization {
              id
              name
            }
            sponsor {
              id
              name
            }
            role {
              name
            }
          }
          fundProject {
            id
            gross_equity
            ownership
          }
          ownedEntity {
            id
            name
          }
          properties {
            total_units
            total_lihtc_units
            entity {
              entityAddresses {
                address {
                  zipCode {
                    city
                    state {
                      name
                      abbreviation
                    }
                    county {
                      name
                      metroStatAreaCounties {
                        metroStatArea {
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ltmodels {
            id
            kpiset {
              pricePerCredits{
                benefitType {
                  id
                  name
                }
                equity_amount
                price
              }
              kpiset_detail {
                hard_debt
                lower_tier_yield
                credit_start_date
                total_equity
              }
            }
            milestone {
              id
              name
            }
            active_model
          }
          sponsor: participants(
            hasRole: { column: NAME, operator: EQ, value: "Sponsor" }
          ){
            sponsor {
              nickname
              name
              id
              __typename
            }
          }
          projectStatuses {
            id
            status {
              id
              name
            }
            statusSequence{
              id
              name
            }
            active
          }
          pipelineProjects(hasPipeline: { column: NAME, operator: EQ, value: "Closing" }) {
            closingDate: pipelineProjectDates(
              where: {
                AND: [
                  { column: INITIAL_TARGET, value: false }
                  {
                    HAS: {
                      relation: "pipelineMilestone"
                      condition: {
                        AND: [
                          {
                            HAS: {
                              relation: "milestone"
                              condition: { column: "name", value: "Closed" }
                            }
                          }
                          {
                            HAS: {
                              relation: "pipeline"
                              condition: { column: "name", value: "Closing" }
                            }
                          }
                        ]
                      }
                    }
                  }
                ]
              }
            ){
              date
            }
          }
          __typename
        }
      }
    }
`
export var get_credit_outlets_list = gql`
  query funds {
    getFunds {
        id
        name
        close_date
        fundType {
          name
        }
        commitments_required
        invested_equity
        specified_equity
        participants {
          person {
            name
            id
          }
          role {
            name
            id
            roleType {
              id
            }
          }
        }
      }
    certificatedOutlets {
      id
      organization {
        name
      }
      specified_equity
    }
    me {
      fundPermissions: permissionsForResource(resourceType: FUND) {
        _edit
        _delete
        _create
      }
    }
  }
  `
// export var get_credit_outlets_list = gql`
//   query funds($page: Int) {
//     funds(page: $page, first: 50) {
//       data {
//         id
//         name
//         close_date
//         fundType {
//           name
//         }
//         invested_equity
//         specified_equity
//         participants {
//           person {
//             name
//             id
//           }
//           role {
//             name
//             id
//             roleType {
//               id
//             }
//           }
//         }
//       }
//       paginatorInfo{
//         currentPage
//         lastPage
//         total
//         perPage
//       }
//     }
//     certificatedOutlets {
//       id
//       organization {
//         name
//       }
//       specified_equity
//     }
//     me {
//       fundPermissions: permissionsForResource(resourceType: FUND) {
//         _edit
//         _delete
//         _create
//       }
//     }
//   }

// `

export var get_fund = gql`
  query fund($id: ID!){
    fund(id: $id){
      id
      name
      fundType {
        name
        id
      }
      ein
      ic_code
      legal_name
      close_date
      certificated_load
      non_certificated_load
      commitments_required
      projectCreditOutlets {
        ...ProjectCreditOutletFields
      }
      syndicationsDetails {
        id
        budget_amt
        syndications_budget_year
      }
      ownedEntities {
        name
        id
        ownedEntityAttributes {
          ownedEntityType {
            name
          }
        }
        ownershipInterests {
          id
          owned_entity_id
          owned_entity_owner_id
          ownerType {
            id
            name
          }
          fundInvestor {
            id
            is_repeat
            is_pending
            notes
          }
          ownershipInterestDetail {
            id
            amount
            investmentClass {
              id
              name
            }
            admission_date
            exit_date
          }
          organization {
            id
            name
          }
        }
      }
      participants {
        id
        person {
          name
          id
        }
        organization {
          name
          sponsor {
            name
          }
          id
        }
        sponsor {
          name
          id
        }
        role {
          name
          id
          roleType {
            name
            id
          }
        }
      }
      fundStatuses{
        id
        status {
          name
          id
        }
      }
      invested_equity
      specified_equity
      ltmodels(hasModelType: {column: NAME, value: "UTModel", operator: EQ}, orderBy: {column: CREATED, order: DESC}) {
        id
        modelType {
          id
          name
        }
        created
      }
    }
    statusesBySequence(sequence_name: "Funds") {
      name
      id
      statusSequenceDetails(hasStatusSequence: { column: NAME, operator: EQ, value: "Funds" }) {
        status_sequence_id
      }
    }
    syndicationsSequence: statusesBySequence(sequence_name: "Syndications") {
      name
      id
      statusSequenceDetails {
        status_sequence_id
        statusSequence {
          id
          name
        }
        index
      }
    }
    fundTypes {
      id
      name
    }
    owned_entity_type_by_name(name: "Special Purpose Entity"){
      id
      name
    }
    fund_project_states {
      id
      name
    }
    investor_type: owner_type_by_name(name: "Investor Member"){
      id
    }
    investment_classes {
      id
      name
    }
    CREARoles: roles_by_role_type_name(name: "CREA Fund"){
      roles {
        active
        id
        name
        roleType {
          name
        }
      }
    }
    thirdPartyRoles: roles_by_role_type_name(name: "Third Party Fund"){
      roles {
        active
        id
        name
        roleType {
          name
        }
      }
    }
    me {
      fundPermissions: permissionsForResource(resourceType: FUND) {
        _edit
        _delete
        _create
      }
    }
  }
  ${PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT}
`

export var get_certificated_outlet = gql`
    query getCertificatedOutlet($id: ID!){
      certificatedOutlet(id: $id){
        id
        organization {
          id
          name
        }
        participants {
          id
          person {
            id
            name
          }
          organization {
            name
            sponsor {
              name
            }
            id
          }
          sponsor {
            name
            id
          }
          role {
            name
            id
            roleType {
              name
              id
            }
          }
        }
        projectCreditOutlets {
          ...ProjectCreditOutletFields
        }
      }
      CREARoles: roles_by_role_type_name(name: "CREA Fund"){
        roles {
          active
          id
          name
          roleType {
            name
          }
        }
      }
      thirdPartyRoles: roles_by_role_type_name(name: "Third Party Fund"){
        roles {
          active
          id
          name
          roleType {
            name
          }
        }
      }
      fund_project_states {
        id
        name
      }
      me {
        fundPermissions: permissionsForResource(resourceType: FUND) {
          _edit
          _delete
          _create
        }
      }
    }
    ${PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT}
`

export var credit_outlets_search_projects = gql`
    query searchProjects($search: String!, $searchLike: String!){
      search_projects(
        first: 10
        name: $searchLike
        orderByInstr: [{ column: NAME, search: $search, order: ASC }])
      {
        data {
          id
          name
          ltmodels {
            kpiset {
              kpiset_detail {
                hard_debt
                lower_tier_yield
              }
            }
          }
          properties {
            entity {
              entityAddresses {
                address {
                  zipCode {
                    city
                    state {
                      name
                      abbreviation
                    }
                    county {
                      metroStatAreaCounties {
                        metroStatArea {
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          projectCredits {
            id
            equity_amount
            amount
            price
            certificated
            crea_syndicated
            projectCreditStatus {
              id
              name
            }
            taxCreditType {
              id
              name
              level
            }
            taxCreditDesignation {
              id
              name
            }

          }
        }
      }
    }
`

export var deal_project_credits = gql`
    query projectCreditOutletsByProjectCredit($id: ID!){
      projectCreditOutletsByProjectCredit(project_credit_id: $id){
        ...ProjectCreditOutletFields
        fund {
          name
          id
          certificated_load
          non_certificated_load
        }
        certificatedOutlet {
          organization {
            name
            id
          }
          certificated_load
          non_certificated_load
        }
      }
    }
    ${PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT}
`

export var get_project_credits = gql`
    query projectCredits($id:ID!){
      project(id: $id){
        name
        id
        sponsor: participants(
          hasRole: { column: NAME, operator: EQ, value: "Sponsor" }
        ){
          sponsor {
            nickname
            name
            id
            __typename
          }
        }
        projectDetail {
          id
          is_flagged_syndications
          syndications_notes
        }
        projectStatuses {
          id
          status {
            id
            name
          }
          statusSequence{
            id
            name
          }
          active
        }
        projectCredits {
          id
          crea_syndicated
          taxCreditType {
            name
            level
            id
          }
          taxCreditDesignation {
            name
            id
          }
          projectCreditOutlets{
            ...ProjectCreditOutletFields
            fund {
              name
              id
              certificated_load
              non_certificated_load
            }
            certificatedOutlet {
              organization {
                name
                id
              }
              certificated_load
              non_certificated_load
            }
          }
        }
      }
      certificatedOutlets {
        id
        organization {
          name
        }
        specified_equity
      }
    }
    ${PROJECT_CREDIT_OUTLET_DETAILS_FRAGMENT}
`
export var get_outlet_project_attribute = gql`
    query projectAttributes($id:ID!){
      project(id: $id){
        projectAttributes {
          id
          attribute {
            id
            name
            active
            attributeType {
              id
              name
            }
          }
        }
      }
    }
`

export var certificated_outlets_search = gql`
    query search_certificated_outlets($searchLike: String){
      search_certificated_outlets(first: 10, name: {column: NAME, operator: LIKE, value: $searchLike}
      ){
        data {
          id
        }
        paginatorInfo{
          currentPage
          lastPage
          total
          perPage
        }
      }
    }
`

export var search_organizations = gql`
    query getOrgs($name: String!, $search: String!) {
        search_organizations(
        name: $name
        first: 10
        page: 1
        orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      ) {
        data {
          id
          name
          entity {
            entity_types {
              type {
                name
                id
                tagType {
                  name
                }
              }
            }
          }
        }
        paginatorInfo {
          currentPage
          lastPage
        }
      }
    }
`

